import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Register.css';
import RegisterAnimation from "./RegisterAnimation";

function Register() {
  const [showPoster, setShowPoster] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    college: '',
    course: '',
    yearOfPassing: '',
    mobile: '',
    email: '',
    internshipType: '' // new field
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const openPoster = () => setShowPoster(true);
  const closePoster = () => setShowPoster(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    const { name, college, course, yearOfPassing, mobile, email, internshipType } = formData;

    if (!name || !college || !course || !yearOfPassing || !mobile || !email || !internshipType) {
      setMessage('Please fill all fields');
      return;
    }

    setIsLoading(true);
    try {
      const res = await axios.post('/api/register/save', formData);

      if (res.data?.success) {
        setMessage('Registration successful!');
        setFormData({
          name: '',
          college: '',
          course: '',
          yearOfPassing: '',
          mobile: '',
          email: '',
          internshipType: ''
        });
      } else {
        setMessage('Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error('Error saving:', err);
      setMessage('Server error. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-top-nav">
        <Link to="/" className="back-home">← Back to Home</Link>
        <div className="top-buttons">
          <a href="/images/NewInternshipPoster.png" target="_blank" rel="noopener noreferrer" className="nav-btn">
            View Poster
          </a>
          <Link to="/about-internship" className="nav-btn">
            About Internship
          </Link>
        </div>
      </div>

      <div className="register-content">
        <div className="register-image-section">
          <RegisterAnimation />
        </div>

        <div className="register-card">
          <h2>Take Part in the Training</h2>
          <form onSubmit={handleSubmit}>
            <input name="name" type="text" placeholder="Name (as per SSC)" value={formData.name} onChange={handleChange} />
            <input name="college" type="text" placeholder="College" value={formData.college} onChange={handleChange} />
            <input name="course" type="text" placeholder="Course" value={formData.course} onChange={handleChange} />
            <input name="yearOfPassing" type="text" placeholder="Year of Passing" value={formData.yearOfPassing} onChange={handleChange} />
            <input name="mobile" type="tel" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} />
            <input name="email" type="email" placeholder="Email" value={formData.email} onChange={handleChange} />

            {/* Internship Type Dropdown */}
            <select
              name="internshipType"
              value={formData.internshipType}
              onChange={handleChange}
              required
              className="form-input"
            >
              <option value="">-- Select Internship Type --</option>
              <option value="Paid Intern">Paid Intern</option>
              <option value="Stipend Intern">Stipend Intern</option>
              <option value="Paid or Stipend Intern">Paid or Stipend Intern</option>
            </select>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Processing...' : 'Register'}
            </button>

            {message && (
              <p
                className={
                  message === 'Please fill all fields'
                    ? 'error-bold'
                    : message.includes('successful')
                      ? 'success'
                      : 'error'
                }
              >
                {message}
              </p>
            )}
          </form>
        </div>
      </div>

      {showPoster && (
        <div className="poster-modal" onClick={closePoster}>
          <span className="close-btn" onClick={closePoster}>&times;</span>
          <img
            src="images/internship.jpg"
            alt="Internship Poster"
            className="poster-modal-img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}

export default Register;
